import { ReactNode } from "react";
import { View } from "./View";

interface ISwitchAppDetailFooterLinkProps {
  linkComponent: ReactNode;
  link_url: string;
}

export interface ISwitchAppLegalAndContactFooterProps {
  sections: ISwitchAppDetailFooterLinkProps[];
  className?: string;
}

export const SwitchAppLegalAndContactFooter = (
  props: ISwitchAppLegalAndContactFooterProps
) => {
  return <View {...props} />;
};
